<div class="row">
	@for (link of links; track $index) {
		<div class="col-12 col-lg-4">
			<app-main-menu-button [link]="link"></app-main-menu-button>
		</div>
	}
</div>
